import { configOption, KahunConfigurationOptionType } from "../lib/annotations";
import { SupportedLanguages } from "./supportedLanguages";

// Currently we support only one - sending conversation link to patients. more to come probably
export enum MessageTouchPoint {
  SendConversationLink = "send-conversation-link",
  ClientInitialReach = "client-initial-reach",
  SendConversationLinkInlineMessage = "send-conversation-link-inline",
  SendNewUserInvitation = "send-new-user-invitation",
  NewClinicCreated = "new-clinic-created",
  RagWelcomeMessage = "rag-welcome-message",
}

export class MessageTemplate {
  @configOption({
    displayName: "Touch Point",
    description: "To what phase/kind of message this template refers to",
    options: MessageTouchPoint,
    displayType: KahunConfigurationOptionType.Choice,
  })
  touchPoint: MessageTouchPoint = MessageTouchPoint.SendConversationLink;
  @configOption({
    description:
      "How does this template is configured in the messaging service provider",
    displayType: KahunConfigurationOptionType.String,
  })
  templateId: string = "";
  @configOption({
    description: "Instead of ID can write a template here",
    displayType: KahunConfigurationOptionType.Text,
  })
  inlineTemplate: string = "";
  @configOption({
    description:
      "List of params used for this email/whatsapp message template, with the following supported " +
      "Macros in values, all keys will be, by default sent as is:" +
      "[#patient_first_name#, #patient_last_name#, #patient_full_name#,#visit_date#, #case_url#, #case_url_text, #clinic_name#, #patient_code_id#]",
    displayType: KahunConfigurationOptionType.JSON,
  })
  templateParams: Record<string, string>;
  @configOption({
    description: "What language code to send",
    options: SupportedLanguages,
    displayType: KahunConfigurationOptionType.Choice,
  })
  language?: SupportedLanguages;
  @configOption(
      {
        description: "Allow this message to be sent without checking if user belongs to clinic",
        displayType: KahunConfigurationOptionType.Boolean,
      }
  )
  enabledForNonClinicUsers: boolean = false;
}
